import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { articleLoader } from '@shared/libs/allLoader'
import AuctionTeamDetail from '../auction-team-detail'

const AuctionTeams = dynamic(() => import('@shared/components/auction/teams'), { loading: () => articleLoader(['g', 's']) })
const LiveTab = dynamic(() => import('@shared/components/auction/liveTab'), { loading: () => articleLoader(['g', 's']) })
const AuctionPlayers = dynamic(() => import('@shared/components/auction/auctionPlayers'), { loading: () => articleLoader(['g', 's']) })
const AuctionCompleted = dynamic(() => import('@shared/components/auction/auctionCompleted'), { loading: () => articleLoader(['g', 's']) })
const SeriesNews = dynamic(() => import('@shared/components/series/seriesNews'), { loading: () => articleLoader(['g', 's']) })
const AuctionLiveBlog = dynamic(() => import('@shared/components/auction/auctionLiveBlog'), { loading: () => articleLoader(['g', 's']) })

function AuctionTabs({ tag, seoData, activeTab, onTabChanges, category, subPages }) {
  if (category?.iPlayerID) {
    return <AuctionPlayers data={category?.playerData} />
  } else if (category?.type === 'home') {
    return <LiveTab auctionId={category?.data?.oAuctionSeries?._id} auctionData={category?.liveData} category={category} overview={category?.overView} />
  } else if (category?.type === 'teams') {
    return <AuctionTeams teams={category?.actionTeamData?.listAuctionTeamFront?.aData} sUrl={subPages?.ac?.sSlug} category={category?.data} />
  } else if (category?.type === 'completed') {
    return <AuctionCompleted players={category?.auctionPlayerList?.listAuctionPlayerFront} category={category} />
  } else if (category?.type === 'news') {
    category.data.eType = 'gt'
    category.data.iId = '6231891bc1174ac2e3f63aa2'
    return <SeriesNews data={category?.home?.oArticles} category={category?.data} />
  } else if (category?.type === 'live-blog') {
    return <AuctionLiveBlog liveArticleData={category?.liveArticleData} category={category?.data} />
  } else if (category?.type === 'team-detail') {
    return <AuctionTeamDetail team={category?.teamDetail?.oData} allTeam={category?.teamList?.aData} category={category?.data} />
  } else {
    return null
  }
}
AuctionTabs.propTypes = {
  seoData: PropTypes.object,
  tag: PropTypes.object,
  activeTab: PropTypes.string,
  onTabChanges: PropTypes.func,
  auctionData: PropTypes.object,
  category: PropTypes.object,
  subPages: PropTypes.object
}
export default AuctionTabs
